/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { useShowError } from "~/components/Error/useShowError";
import { ClearButton } from "~/components/InlineEdit/ClearButton";
import { showSuccess } from "~/components/Toast";
import { RouteParams } from "~/models";
import { AssignmentRuleFlat } from "~/models/assignmentRule";
import { useAxios, generateActionSuccessText } from "~/tools";

type Props = {
  assignmentRule: AssignmentRuleFlat;
  refetch: () => Promise<void>;
};

export function AREnvStatusClear({ assignmentRule, refetch }: Props) {
  const { customerId } = useParams<RouteParams>();

  const { showError } = useShowError();
  const { Axios } = useAxios();

  const [isSubmittingLoading, setIsSubmittingLoading] = React.useState(false);

  const handleClear = async () => {
    setIsSubmittingLoading(true);
    const organizeValues = {
      ...assignmentRule,
      environmentStatus: null,
    };

    try {
      await Axios().put(
        `/customers/${customerId}/assignmentRules/${assignmentRule.id}`,
        organizeValues
      );
      showSuccess(
        generateActionSuccessText("Assignment Rule status")()("cleared")()
      );
      await refetch();
    } catch (e) {
      showError(e?.response);
    } finally {
      setIsSubmittingLoading(false);
    }
  };

  return <ClearButton onClick={handleClear} isLoading={isSubmittingLoading} />;
}
